<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-tabs>
                <b-tab title="Basisgegevens" active>
                  <b-row>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Campagneacties">
                            <b-form-input type="text" required v-model="item.campaign_actions" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { updateData, getData } from '../../api';

export default {
  name: 'voting-goal',

  data() {
    return {
      saveButtonDisabled: false,
      editable: false,
      item: {},
    };
  },

  methods: {
    async refresh() {
      await this.getItem();
    },

    async getItem() {
      this.item = await getData('voting-goals/' + this.$route.params.id).then(
        (response) => response.data.data
      );
    },

    async saveItem() {
      this.saveButtonDisabled = true;

      let formData = new FormData();
      Object.keys(this.item).forEach(key => {
        formData.append(key, this.item[key]);
      });

      const request = await updateData('voting-goals/' + this.$route.params.id, formData);

      if (request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
  },

  computed: {
    userRole: function() {
      return this.$store.state.userRole;
    },
  },
  beforeMount() {
    this.getItem();
  },
};
</script>

